// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dot[data-v-8966a24a] {\n  background: #999;\n  border-radius: 5000px;\n}\n.dot.active[data-v-8966a24a] {\n  background: #ccc;\n}\n.h-90[data-v-8966a24a] {\n  height: 90%;\n}\n.h-10[data-v-8966a24a] {\n  height: 10%;\n}\n", ""]);
// Exports
module.exports = exports;
